import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
    getAllJournalEntries
} from "../services/journal";

export default function Journal() {

    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isTablet, setIsTablet] = useState(false);
    useEffect(() => {

        async function loadJournal() {

            const results =
                await getAllJournalEntries();

            setEntries(results);

            setLoading(false);

        }
        setIsTablet(
            window.innerWidth >= 768 &&
            window.innerWidth < 1200
        );
        loadJournal();

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

    }, []);

    

    return (

        <div
            style={{
                maxWidth: "min(900px, 95vw)",
                margin: "0 auto",
                padding: 20,
            }}
        >

           <div
    style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 24,
        paddingTop: "calc(env(safe-area-inset-top) + 16px)",
    }}
>
                <h2
                    style={{
                        margin: 0,
                    }}
                >
                    📖 Learning Journal
                </h2>

                <Link
                    to="/"
                    style={{
                        fontWeight: 600,
                        textDecoration: "none",
                    }}
                >
                    ← Home
                </Link>
            </div>
{loading && (
    <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Loading journal...
    </p>
)}
{!loading && entries.length === 0 && (
            

                <div
                    style={{
                        marginBottom: 20,
                        padding: 16,
                        border: "1px solid #ddd",
                        borderRadius: 12,
                        background: "white",
                    }}
                >

                    <h2>Your Learning Journal is empty</h2>

                    <p>

                        As you complete activities, your
                        personalised insights and reflections
                        will be stored here.

                    </p>

                </div>

            )}

            {!loading && entries.map(entry => (

                <div

                    key={entry.id}

                    style={{

                        marginTop: 16,

                        padding: 20,

                        border: "1px solid #ddd",

                        borderRadius: 12,

                    }}

                >

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 6,
                        }}
                    >

                        <h2
                            style={{
                                margin: 0,
                                fontSize: "1.2rem",
                            }}
                        >
                            {entry.activityTitle}
                        </h2>

                        {entry.result ? (

                            <div
                                style={{
                                    background: "#2d7ff9",
                                    color: "white",
                                    padding: "4px 10px",
                                    borderRadius: 20,
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                }}
                            >
                                {entry.result}
                            </div>

                        ) : entry.score != null ? (

                            <div
                                style={{
                                    background: "#2d7ff9",
                                    color: "white",
                                    padding: "4px 10px",
                                    borderRadius: 20,
                                    fontSize: "0.9rem",
                                    fontWeight: "bold",
                                }}
                            >
                                {entry.score}
                            </div>

                        ) : null}

                    </div>

                    <div
                        style={{
                            lineHeight: 1.6,
                            color: "#444",
                        }}
                        dangerouslySetInnerHTML={{
                            __html: entry.summary
                        }}
                    />

                </div>

            ))}

        </div>

    );

}